require('./accordion.js');
require('./mobileMenu.js');
require('./unnepekAruhazaForm.js');
require('./remodal.js');
require('./searchForm.js');
require('./quantity.js')

var windowWidth = undefined;
var mainHeader = undefined;
var headerBorder = undefined;
var mobileMenu = undefined;



$(document).ready(function(){
  windowWidth = window.innerWidth;
  mainHeader = $('.main-header');
  headerBorder = $('[data-purpose="header-scroll-border"]');
  var searchContainers = $('[data-purpose="search-container"]');

  if (searchContainers && searchContainers.length > 0) {
    searchContainers.each(function(){
      new SearchForm($(this));
    })
  }

  if (headerBorder.length == 0) {
		headerBorder = mainHeader;
	}

  var resizeFn = function() {
    if (window.innerWidth != windowWidth) {
      windowWidth = window.innerWidth;
      $(document).trigger('unnepekaruhaza.window_width_changed', windowWidth);
    }
  };

  window.addEventListener('resize', resizeFn);

  $('[data-purpose="add-to-cart"]').click(function(e){
    e.preventDefault();
    console.log('kosárba rakni a terméket');
    if (!$(this).hasClass("helium-button")) {
      openRemodalContent('heliumRemodal');
    }
  });

  var scrollFn = function() {
    var height = headerBorder.outerHeight(true) + headerBorder.offset().top;
    var scrollTop = $(window).scrollTop();

    if (height <= scrollTop && !mainHeader.hasClass('opened-fix-menu')) {
      mainHeader.addClass('opened-fix-menu');
    } else if (height > scrollTop && mainHeader.hasClass('opened-fix-menu')) {
      mainHeader.removeClass('opened-fix-menu');
      $('.main-header .fix-content').find('.submenu').hide(0, function() {
				var submenu = $(this);
				setTimeout(function(){
					submenu.removeAttr('style');
				}, 250);
			});
    }
  }

  window.addEventListener('scroll', scrollFn);

  $('.accordion-list').each(function(ind, el) {

		var options = {};
		var th = $(el);

		if (th.data('single-active-item') != undefined) options.singleActiveItem = true;
		if (th.data('active-index') != undefined) options.activeIndex = th.data('active-index');
		if (th.data('from-width') != undefined) options.fromWidth = parseInt(th.data('from-width'));

		new AccordionList(th, options);
  });

  mobileMenu = new MobileMenu($('#mobileMenu'), {
    'categories': typeof mobileMenuCategories !== 'undefined' ? mobileMenuCategories : [],
    'listSelector': '[data-purpose="mobile-menu-categories-list"]'
  });

  $('[data-purpose="opener-item"]').click(function(){
    var parent = $(this).parent();
    if (!parent.hasClass('opened')) {
      parent.addClass('opened');
      parent.removeClass('let-open');
    } else {
      parent.removeClass('opened');
      parent.addClass('let-open');
    }
  });

  var toClone = $('[data-purpose="submenu-to-clone"]');
  if (toClone.length > 0) {
    var target = $('[data-purpose="submenu-clone-target"]');
    var item = toClone.find('.header-submenu');
    if (target.length > 0 && item.length == 1) {
      target.append(item.clone());
    }
  }


  $('[data-purpose="general-form"]').each(function(){
    new UnnepekAruhazaForm($(this));
  });

  $('[data-purpose="remodal-open"]').click(function(){
    if ($(this).data('popup-target')) {
      openRemodalContent($(this).data('popup-target'));
    }
  });
  
	$('[data-purpose="add-to-cart"]').click(function(e){
		e.preventDefault();
		var menny = $(this).closest('.form-content').find($('[data-purpose="quantity"]')).val();
		var k_menny = menny != undefined ? menny : 1;
		var helium = $('[data-purpose="helium-chk"]').prop('checked') ? $('[data-type="helium"]').val() : 0;
		// helium = helium != undefined ? helium : 0;
		var disc = $('.spec-disc').attr('data-dsc');
		var d = disc != undefined ? disc : 0;
		var tid = $(this).attr('id');
		var redir = $(this).data('target');
		checkQua(tid, d, k_menny, helium, redir);
		console.log(tid);
	});
	  
	$('[data-purpose="call-me-later"]').click(function(e){
		e.preventDefault();
		var prod_id = $(this).attr('id');
		var notification_remodal = $('[data-remodal-id="notification-remodal"]').remodal();
		notification_remodal.open();
		$('input[name="tid"]').val(prod_id);
	});
});

function openRemodalContent(remodal_id) {
  var item = $('[data-remodal-id="'+remodal_id+'"]');
  if(item.length > 0){
    item.remodal().open();
  }
}

var onloaded = function() {
  setTimeout(function(){
      $('.preloaded-css').each(function(){
          if ($(this).attr('rel') === 'preload') {
              $(this).attr('rel', 'stylesheet');
          }
      });

      $('#preloader').fadeOut(300, function(){
          $(this).remove();
      });
  }, 50);

  $('.last-breadcrumb-item').click(function(e){
    e.preventDefault();
  });
}

window.addEventListener('load', onloaded);


//qua
	function confAdd(keszlet, prid, msg) {
		var nostock = $('[data-remodal-id=nostock-remodal]');
		$('.nostock-msg').html(msg);
		nostock.remodal().open();
		// $(document).on('confirmation', '.remodal', function () {
		nostock.find('[data-purpose="confirm-button"]').click(function(){
			$.ajax({
				url: "ajax/checkquantity.php",
				type: "post",
				data: {termek_id: prid, k_menny: keszlet},
				dataType: "json"
			})
			.done(function (data){
				if (data['ok'] == "true") {
					var notyf = new Notyf();
					$('.minicart').html(data['cartview']);
					// $('minicart').append(data['om']);
					notyf.confirm('A termék kosárba helyezve');
				}
			});
			nostock.remodal().close();
		});
		nostock.find('[data-purpose="cancel-button"]').click(function(){
			nostock.remodal().close();
		});

	}

//qua	
	function checkQua(tid, d, k_menny, helium, redir) { 
		var request;
		if (request) {
			request.abort();
		}
		var request = $.ajax({
			url: "ajax/checkquantity.php",
			type: "post",
			data: {termek_id: tid, disc: d, k_menny: k_menny, fujva: helium, redir: redir},
			dataType: "json"
			});
		request.done(function (data){
			$('.hcounter').text(data['tetelek_szama']); 
			var notyf = new Notyf();
			if (data['ok'] == "true") {
				var product_name = $('#' + tid).attr('data-product-name');
				var product_price = $('#' + tid).attr('data-product-price');
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'event': 'AddToCart',
					'productId': tid,
					'productName': product_name,
					// 'productCategory': 'TEszt kategória',
					'productPrice': product_price
				});
				notyf.confirm('A termék kosárba helyezve');
				if (typeof(data['redir']) != "undefined") {
					window.location.href = 'kosaram';
				}
			}
			else {  
				if (data['nulla'] == "true") {
					notyf.alert(data['message']);
				} 
				else {
					confAdd(data['raktaron'], data['prid'], data['message']);
				}
			}
			// console.log(data);
		});
	}

	//qua
// in the main cart
function confCartAdd(keszlet, prid, msg) {
	var notyf = new Notyf();
	notyf.alert(msg);
	 $('div[data-pid=' + prid + '] .quantityy-field').val(3); 
}



//qua
function toCart(cart) {
	var request;
	if (request) {
		request.abort();
	}
	var k_menny = 1;
	var serializedData = {termek_id: cart, k_menny: k_menny};
	var request = $.ajax({
		url: "ajax/cart_checkquantity.php",
		type: "post",
		data: serializedData,
		dataType: "json"
	});

	request.done(function (data){
		if (data['ok'] == "true") {
			$('.kosar_box').html(data['cartview']);
			$('#cart_box').html(data['maincartview']);
			$('.counter').text(data['tetelek_szama']);
		}
		else {  
			confCartAdd(data['raktaron'], data['prid'], data['message']);
		}
	});
}

function Ajandekba(pid) {
		var request;
		if (request) {
			request.abort();
		}
		var Data = {aji_id: pid};
		var request = $.ajax({
			url: "ajax/ajandekba.php",
			type: "post",
			data: Data,
			dataType: "json"
			});

		request.done(function (data){
			// alert(data);
			if (data['ok'] == "true") {
				$('.aji_info').html(data['ajandek']);
			}
		});
	}
	
$(document).ready(function() {
	$('#cookie_policy_btn').click(function(){ 
		createCookie('ua_pcookie',true,980);
		$('#cookie_policy').fadeOut(400);
		$('#cookie_policy').remove();
	});
});	
	
function createCookie(name,value,days){if(days){var date=new Date();date.setTime(date.getTime()+(days*24*60*60*1000));var expires="; expires="+date.toGMTString();}
	else var expires="";document.cookie=name+"="+value+expires+"; path=/";}
function readCookie(name){var nameEQ=name+"=";var ca=document.cookie.split(';');for(var i=0;i<ca.length;i++){var c=ca[i];while(c.charAt(0)==' ')c=c.substring(1,c.length);if(c.indexOf(nameEQ)==0)return c.substring(nameEQ.length,c.length);}
return null;}
function eraseCookie(name){createCookie(name,"",-1);}

